import {Injectable, Type} from "@angular/core";
import {EditRoute} from "./main/main.routing";

/**
 * Provides functions to retrieve information about the routing. Its routes variable needs to be provided.
 */
@Injectable()
export class RoutingDiscoveryService {

    routes: any;

    /**
     * Find a component type for a path
     * @param {string} path
     * @returns {any}
     */
    findRoutingComponent(path: string): Type<any> {
        for (const route of this.routes) {
            if (path === route.editPath || path === route.path) {
                return route.component;
            }
        }
        return null;
    }

    /**
     * Find a path by a component type
     * @param {Type<any>} component
     * @returns {EditRoute}
     */
    findComponentRoute(component: Type<any>): EditRoute {
        for (const route of this.routes) {
            if (route.editPath && component === route.component) {
                return route;
            }
        }
        return null;
    }
}
